
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO, generateBreadcrumbSchema } from '../../utils/seo';

const TermsPage = () => {
  // SEO Configuration
  useSEO({
    title: 'Terms of Service - PURECODE Ltd',
    description:
      'PURECODE Ltd Terms of Service. Read our terms and conditions for using our IT consultancy services and website.',
    canonical: 'https://purecode.uk/terms',
    schema: generateBreadcrumbSchema([
      { name: 'Home', url: '/' },
      { name: 'Terms of Service', url: '/terms' },
    ]),
  });

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-600 via-cyan-600 to-blue-600 text-white py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4">
              Terms of Service
            </h1>
            <p className="text-xl text-teal-100">
              Last updated: {new Date().toLocaleDateString('en-GB')}
            </p>
          </div>
        </div>
      </section>

      {/* Terms Content */}
      <section className="py-16 bg-white flex-grow">
        <div className="mx-auto max-w-4xl px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            {/* ... rest of existing content ... */}
            <p>
              {/* Example placeholder paragraph – replace with your actual terms */}
              By accessing or using this website, you agree to be bound by these Terms of
              Service. If you do not agree with any part of these terms, you must not use
              the site.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPage;
